import { render, staticRenderFns } from "./MessagesDemo.vue?vue&type=template&id=916afd8e&scoped=true&"
import script from "./MessagesDemo.vue?vue&type=script&lang=js&"
export * from "./MessagesDemo.vue?vue&type=script&lang=js&"
import style0 from "./MessagesDemo.vue?vue&type=style&index=0&id=916afd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916afd8e",
  null
  
)

export default component.exports